import * as React from 'react';
import { setCategoryFilter } from '../actions';
import { directoryDispatch } from '../affiliate-directory';

interface IDirectoryFilterCategory
{
  selectedCategoryFilter: string;
  categoryList: Array<string>;
}

class DirectoryFilterCategory extends React.Component<IDirectoryFilterCategory, any>{

  constructor(props)
  {
    super(props);
  }

  sendAction(e)
  {
    directoryDispatch()(setCategoryFilter(e.target.value));
  }

  clearFilter(e)
  {
      directoryDispatch()(setCategoryFilter(''));
  }
  
  render()
  {
      const listCategories = this.props.categoryList.sort().map((category, index) =>
          (category != null ? <option key={index} className="affiliate-filter-category-item" value={category.toLowerCase()}>{category}</option> : null)
    );

    return (
      <div className="filter-option affiliate-filter-selector-container">
        <label className="affiliate-filter-label" htmlFor="affiliate-category">Category</label>
        <em className="affiliate-filter-reset"><button onClick={this.clearFilter.bind( this )}> Clear</button></em>

            <select
                name="affiliate-category"
                className="affiliate-filter-item affiliate-filter-selector"
                id="affiliate-category"
                onChange={this.sendAction.bind(this)}
                value={this.props.selectedCategoryFilter} >
          <option selected className="affiliate-filter-category-item" value="Select a Category">Select a Category</option>
          {listCategories}
        </select>
      </div>
    )
  }
}

export default DirectoryFilterCategory;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/affiliate-directory/filters/directory-filters-category.tsx